export class AnnotationReviewStatus {
    public id: number;
    constructor(
         public annotationId:number,
         public userId: string,
         public status: number
      ) { }
 
 }